<div id="carouselUnidades" class="carousel slide d-block d-md-none" data-bs-ride="carousel" data-bs-interval="3000">
  <div class="carousel-inner">
    <div *ngFor="let unidade of unidades; let i = index" class="carousel-item" [ngClass]="{'active': i === 0}" (click)="openTelefoneMobile(unidade.nome, unidade.telefone, unidade.linkMapa)">
      <div class="card-unidade">
        <img [src]="unidade.foto" alt="Unidade Cancian" class="card-image-unidade" />  
        <div class="card-footer">
          <h3>{{ unidade.nome }}</h3>
          <p>{{ unidade.endereco }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Controles de Navegação -->
  <button class="carousel-control-prev" type="button" [attr.data-bs-target]="'#carouselUnidades'" data-bs-slide="prev" style="z-index: 100;">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  
  <button class="carousel-control-next" type="button" [attr.data-bs-target]="'#carouselUnidades'" data-bs-slide="next" style="z-index: 100;">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  
</div>


<!-- Exibição Normal para Desktop -->
<div class="card-container-cancian d-none d-md-flex">
  <div *ngFor="let unidade of unidades" class="card-unidade">
    <img [src]="unidade.foto" alt="Unidade Cancian" class="card-image-unidade" />
    <div class="card-actions">
      <a (click)="openTelefone(unidade.nome, unidade.telefone)" title="Ligar"> 
        <mat-icon class="icon-vermelho">phone</mat-icon>
      </a>
      <a [href]="unidade.linkMapa" target="_blank" title="Ver no mapa">
        <mat-icon class="icon-vermelho">location_on</mat-icon>
      </a>
    </div>
    <div class="card-footer">
      <h3>{{ unidade.nome }}</h3>
      <p>{{ unidade.endereco }}</p>
    </div>
  </div>
</div>